import { render, staticRenderFns } from "./AddFolderModal.vue?vue&type=template&id=30bc4d98&"
import script from "./AddFolderModal.vue?vue&type=script&lang=js&"
export * from "./AddFolderModal.vue?vue&type=script&lang=js&"
import style0 from "./AddFolderModal.vue?vue&type=style&index=0&id=30bc4d98&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports